'use strict';

var ConstantView = Backbone.Marionette.ItemView.extend({
    template: require('components/devices/templates/controller/characteristic_constant'),

    events: {
        'change .js-edit-value': 'editValue',
    },

    serializeData: function () {
        var data = { values: _.pick(this.options.values.values, ['fixedValueDay', 'fixedValueNight']) };
        data.readOnly = this.options.readOnly;
        return data;
    },

    editValue: function (e) {
        var id = e.target.id;
        var value = parseFloat(e.target.value);
        if (isNaN(value)) {
            return;
        }
        this.options.values.setValue(id, value * 10);
        value = this.options.values.getValue(id).val / 10;
        // rewrite the parsed value to the input element
        e.target.value = value;
    },

    getValues: function (circuitNr) {
        return this.options.values.getAllWriteableValues(circuitNr);
    },
});

module.exports = ConstantView;
